// Hideo - what every Vue dialog does with the dialog stack (src/stores/dialogs.ts): registers itself while it is shown
// (Esc, the keyboard shortcuts it blocks, "the user is typing" for the online sync) and closes on a click outside only
// when the press started outside too (selecting text in a field and releasing outside must not close it).
// Used by AppDialog.vue, CardDialog.vue and SearchDialog.vue. Opening plays the themes' "open" sound (src/features/sounds.ts).
import { onBeforeUnmount, onMounted } from 'vue'
import { useDialogsStore } from '../stores/dialogs'
import type { DialogEntry } from '../features/dialogs'
import { playSound } from '../features/sounds'

/** Registers the dialog; returns the overlay's mousedown / click handlers (outside: whether a click outside closes it) */
export function useDialogEntry(entry: Omit<DialogEntry, 'close'>, close: () => void, outside: () => boolean = () => true) {
  const dialogs = useDialogsStore(), e: DialogEntry = { ...entry, close }
  onMounted(() => { dialogs.register(e); playSound('open') })   // the themes' sounds: off by default
  onBeforeUnmount(() => dialogs.unregister(e))
  let downOnOverlay = false
  return {
    onDown(ev: MouseEvent) { downOnOverlay = ev.target === ev.currentTarget },
    onClick(ev: MouseEvent) {
      if (outside() && downOnOverlay && ev.target === ev.currentTarget) close()
      downOnOverlay = false
    }
  }
}
